<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script>
import { useLocalStorage, lowerString } from '@/helpers';
import { changeLanguageInHelpers } from '@/helpers/validations';
import { mapState } from 'pinia';
import { useGlobalStore } from '@/store/Modules/global';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { getAuthFirebase } from "@/helpers/Firebase-Setup/firebaseSetup"

export default {
  name: 'App',
  computed: {
    ...mapState(useGlobalStore, {
      global: (store) => store,
      isRTL: (store) => store.isRTL,
      isUserLogged: (store) => store.isUserLogged,
    }),
    langQuery() {
      const route = useRoute();
      return route?.query?.locale;
    },
  },
  methods: {
    changeLanguage(lang) {
      lang = lowerString(lang);
      const availableLanguages = ['ar','en'];
      if (!lang || !availableLanguages.some((lng) => lowerString(lng) === lang)) {
        return;
      }
      this.$i18n.locale = lang;
      changeLanguageInHelpers(lang);
      if (lang === 'ar') {
        this.changeLayoutDirection('rtl', lang);
      } else {
        this.changeLayoutDirection('ltr', lang);
      }
    },
    registerUIDIfNotFound(){
        if (process.client) {
          this.$nextTick(() => {
            let cookieUID = useCookie('UID', {
              'secure': true
            });
          
            if(!cookieUID?.value){
              const fpPromise = FingerprintJS?.load();
              fpPromise
              .then(fp => fp.get())
              .then(result => {
                // This is the visitor identifier:
                const visitorId = result.visitorId
                cookieUID.value = visitorId;
              })
            }
          });
        }
    },
    async authFirebase() {
      if (this.isUserLogged) {
        try {
          const UID = useCookie("UID")?.value || false;
          if (!UID) {
            throw new Error("No UID found");
          }
          const res = await this.makeRequest({
            owner: this.MAINROLES.user,
            url: `${this.APIREQUESTS.user.getTokenFirestore.url}/${UID}`,
            method: this.APIREQUESTS.user.getTokenFirestore.method,
          });
          const token = res?.data?.authToken;
          const userID = res?.data?.userId;
          const userObject = {
            token: token,
            userID: userID,
            storeIDs: res?.data?.storeIDs || [],
          };
          localStorage.setItem('userObject', JSON.stringify(userObject));
          await getAuthFirebase(userObject);
        } catch (err) {
          console.error("Error fetching user token: ", err);
          throw err;
        }
      } else {
      }
    }
  },
  watch: {
    langQuery: {
      immediate: true,
      handler(val){
        // sets current language with the lang query if found in the URL
        if (val) {
          useLocalStorage({
            type: 'set',
            key: 'language',
            value: lowerString(val),
          });
        }
      }
    },
  },
  async created() {
    // let coordinates=await this.getCurrentLocation()

    // once the app gets initialized
    if(process.client){
      const localStorageData = useLocalStorage({ type: 'get' });
      if (!localStorageData) {
        useLocalStorage({ type: 'reset' });
      } else {
        this.global.updateLocalStorageCopy(localStorageData);
      }
      let lang = localStorageData?.language;
      this.changeLanguage(lang);
      // once a language update occurs in the localStorage
      useLocalStorage({
        type: 'listener',
        callBack: (data) => {
          let { language = 'ar' } = data || {};
          language = lowerString(language);
          this.changeLanguage(language);
        },
      });
    }
  },
  mounted(){
    // generate a UID and store it in cookies
    this.registerUIDIfNotFound();
    // this.authFirebase();
  }
};
</script>
<style></style>
